import { authApi } from '../authentication/authentication.actions';
import {
  IForgotPasswordCheckCodeRequest,
  IForgotPasswordData,
  IForgotPasswordGenerateCodeRequest,
  IForgotPasswordGenerateCodeResponse,
  IForgotPasswordRequest,
  IPasswordChangeRequest,
} from '../../types/forgotPassword.types';
import { API_ROUTES } from '../../constants/API_ROUTES';

export const forgotPasswordApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    startPasswordReset: builder.mutation<IForgotPasswordData, IForgotPasswordRequest>({
      query: (data) => ({
        url: API_ROUTES.auth.forgotPassword.init,
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
    }),
    generateCode: builder.mutation<IForgotPasswordGenerateCodeResponse, IForgotPasswordGenerateCodeRequest>({
      query: (credentials) => ({
        url: API_ROUTES.auth.forgotPassword.generateCode,
        method: 'POST',
        body: credentials,
        credentials: 'include',
      }),
    }),
    checkCode: builder.mutation<IForgotPasswordGenerateCodeResponse, IForgotPasswordCheckCodeRequest>({
      query: (data) => ({
        url: API_ROUTES.auth.forgotPassword.checkCode,
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
    }),
    changePassword: builder.mutation({
      query: (data: IPasswordChangeRequest) => ({
        url: API_ROUTES.auth.forgotPassword.finish,
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
    }),
  }),
});

export const { useStartPasswordResetMutation, useGenerateCodeMutation, useCheckCodeMutation, useChangePasswordMutation } = forgotPasswordApi; 